import type { SpherePhase } from './sim/sphereDuel';

export const SPHERE_TICK_MS = 50;
/** Anchors within this distance are visually continuous at whole-second precision. */
export const SPHERE_CLOCK_SNAP_TOLERANCE_TICKS = 2;

export interface SphereClockAnchor {
  phase: SpherePhase;
  remainingTicks: number;
  receivedAtMs: number;
}

/** Extrapolate display-only time; gameplay continues to use server state exclusively. */
export function extrapolateSphereTicks(anchor: SphereClockAnchor, nowMs: number): number {
  if (anchor.phase === 'loading' || anchor.phase === 'paused' || anchor.phase === 'settled') {
    return Math.max(0, anchor.remainingTicks);
  }
  const elapsedTicks = Math.max(0, Math.floor((nowMs - anchor.receivedAtMs) / SPHERE_TICK_MS));
  return Math.max(0, anchor.remainingTicks - elapsedTicks);
}
